<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card>
      <v-btn
        icon
        class="ml-4 mt-4"
        color="primary"
        @click.stop="to($options.Steps.identification)"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>
      <CloseDialogButton :close="closeAuth" />
      <div class="align-center d-flex flex-column">
        <Confirmation
          class="pt-10"
          :code="code"
          :fetchCart="fetchCart"
          :identification="identification"
          :to="to"
          :updateCode="updateCode"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { Steps } from "@/types/signup.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import Confirmation from "@/components/Auth/SignUp/Content/Confirmation.vue";

export default {
  name: "SignUpConfirmationDialog",
  components: {
    CloseDialogButton,
    Confirmation,
  },
  props: {
    closeAuth: Function,
    code: Object,
    fetchCart: Function,
    identification: Object,
    outsideClick: Function,
    show: Boolean,
    to: Function,
    updateCode: Function,
  },
  Steps,
};
</script>
